import { WixBiSession, BusinessLogger, Experiments } from '@wix/thunderbolt-symbols'
import { IFeatureState } from 'thunderbolt-feature-state'
import { ReporterState, ReporterSiteConfig } from '..'
import { setState } from '../utils'
import { LoadedScripts } from '../tag-manager/types'
import { onTagManagerReady } from '../tag-manager'
import { getReporterProps } from './get-reporter-props'

export async function init(
	siteConfig: ReporterSiteConfig,
	wixBiSession: WixBiSession,
	businessLogger: BusinessLogger,
	featureState: IFeatureState<ReporterState>,
	experiments: Experiments
) {
	const api = await import('../api' /* webpackChunkName: "reporter-api" */)
	const reporterProps = getReporterProps(siteConfig, wixBiSession)
	api.initDefaultChannels(reporterProps, businessLogger, experiments)

	onTagManagerReady(initChannels)

	function initChannels(loadedScripts: LoadedScripts) {
		api.initChannels(reporterProps, loadedScripts)
		setState(featureState, { tagManagerReady: true })
		handleDeferredPageView()
	}

	function handleDeferredPageView() {
		featureState.get().sendDeferredPageView()
		setState(featureState, { sendDeferredPageView: () => {} })
	}
}
